import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { StudentPersonalInformationComponent } from './student-personal-information/student-personal-information.component';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { StudentAcademicQualificationComponent } from './student-academic-qualification/student-academic-qualification.component';

import { StudentCompetitiveTestScoresComponent } from './student-competitive-test-scores/student-competitive-test-scores.component';

import { StudentWorkExperienceComponent } from './student-work-experience/student-work-experience.component';


@Component({
  selector: 'app-student-admission-profile',
  templateUrl: './student-admission-profile.component.html',
  styleUrls: ['./student-admission-profile.component.scss']
})
export class StudentAdmissionProfileComponent implements OnInit {

  @Input() admissionData: any;
  @Input() applicationData: any;
  @Input() sectionCompletionData: any;
  @Output() updateProfileSectionData = new EventEmitter<boolean>();
  active: 1 | undefined;

  @ViewChild('personalInfoComp') personalInfoComponent: StudentPersonalInformationComponent;
  @ViewChild('academicQualificationComp') academicQualificationComponent: StudentAcademicQualificationComponent
  @ViewChild('competitiveTestInfoComp') competitiveTestInfoComponent: StudentCompetitiveTestScoresComponent
  @ViewChild('workExperienceComp') workExperienceComponent: StudentWorkExperienceComponent

  ngOnInit(): void {
  }


  getUpdatedProfileData(ev: boolean) {

    if (ev) {
      this.updateProfileSectionData.emit(true);
    }
  }

  onNavChange(event: NgbNavChangeEvent) {
    

    if (event.activeId === 1 && this.personalInfoComponent) {
      this.personalInfoComponent.triggerSubmit();
    }

    else if (event.activeId === 2 && this.academicQualificationComponent) {
      this.academicQualificationComponent.triggerSubmit();
    }
    else if (event.activeId === 3 && this.competitiveTestInfoComponent) {
      this.competitiveTestInfoComponent.triggerSubmit();
    }
    else if (event.activeId === 4 && this.workExperienceComponent) {
      this.workExperienceComponent.triggerSubmit();
    }
  }

}
